import { render, staticRenderFns } from "./CommonHeading.vue?vue&type=template&id=0c91e2af&scoped=true&lang=pug&"
import script from "./CommonHeading.vue?vue&type=script&lang=js&"
export * from "./CommonHeading.vue?vue&type=script&lang=js&"
import style0 from "./CommonHeading.vue?vue&type=style&index=0&id=0c91e2af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c91e2af",
  null
  
)

export default component.exports